import { Typography } from "@mui/material";
import moment from "moment";

import { TAccount, TMyClass } from "../../../../../@types";
import { useAccount } from "../../../../../hooks/useAccount";
import noAvatarImage from "../../../../imagenes/no_avatar.svg";
import { Link } from "react-router-dom";

export type TRecentAppointmentItemProps = {
	recentAppointment: TMyClass;
};

export function RecentAppointmentItem(props: TRecentAppointmentItemProps) {
	const { account } = useAccount();
	let opponent: TAccount | undefined;
	let noteLink = "";
	let noteText = "";
	if (account?.id === props.recentAppointment.userId) {
		opponent = props.recentAppointment.lesson.course?.teacher;
		noteLink = `/learning/${props.recentAppointment.lesson.course.courseSlug}?class=${props.recentAppointment.id}&tab=summary`;
		noteText = "View notes";
	} else if (account?.id === props.recentAppointment.teacherId) {
		opponent = props.recentAppointment.user;
		noteLink = `/teaching/${props.recentAppointment.lesson.course.courseSlug}/${props.recentAppointment.userId}?class=${props.recentAppointment.id}&tab=summary`;
		noteText = "Add notes";
	}

	const airHoursText = `${props.recentAppointment.airHours.toFixed(1)} hrs in Flight`;
	const simulatorHoursText = `${props.recentAppointment.simulatorHours.toFixed(1)} hrs in Sim`;
	const milesFlownText = `${props.recentAppointment.milesFlown} miles Flown`;

	const showFlightData =
		props.recentAppointment.airHours > 0 ||
		props.recentAppointment.simulatorHours > 0 ||
		props.recentAppointment.milesFlown > 0;
	const showFlightSummary =
		showFlightData || props.recentAppointment.flightSummary;

	if (!opponent) {
		return null;
	}

	return (
		<div className="recent-appointment-item-container">
			<div className="time-container">
				<Typography className="big-text bold">
					{moment(props.recentAppointment.startTime).format("ddd")}
				</Typography>
				<Typography className="normal-text">
					{moment(props.recentAppointment.startTime).format("MMM DD")}
				</Typography>
				<Typography className="big-text bold">
					{moment(props.recentAppointment.startTime).format("HH:mm")}
				</Typography>
			</div>
			<div className="appointment-info-container">
				<div className="user-info-container">
					<img
						src={
							opponent.profile?.thumbnail ||
							opponent.profile?.url ||
							noAvatarImage
						}
						className="avatar"
					/>
					<div>
						<Typography className="normal-text bold">
							{opponent.firstName}
						</Typography>
						<Typography className="normal-text">
							{props.recentAppointment.lesson.title}
						</Typography>
					</div>
				</div>
				{showFlightSummary && (
					<div className="flight-summary-container">
						{showFlightData && (
							<div className="flight-data-container item-separator-tiny">
								{props.recentAppointment.airHours > 0 && (
									<Typography className="normal-text">
										{airHoursText}
									</Typography>
								)}
								{props.recentAppointment.simulatorHours > 0 && (
									<Typography className="normal-text">
										{simulatorHoursText}
									</Typography>
								)}
								{props.recentAppointment.milesFlown > 0 && (
									<Typography className="normal-text">
										{milesFlownText}
									</Typography>
								)}
							</div>
						)}
						{props.recentAppointment.flightSummary && (
							<div className="item-separator-tiny">
								<Typography className="normal-text bold">Notes:</Typography>
								<Typography
									className="normal-text summary-note"
									whiteSpace="break-spaces">
									{props.recentAppointment.flightSummary}
								</Typography>
							</div>
						)}
					</div>
				)}
				<div className="buttons-group-container">
					<Link
						to={`/messages/${opponent.userId}`}
						className="appointment-button no-underline-link black-text">
						<Typography className="normal-text" textAlign="center">
							{`Message ${opponent.firstName}`}
						</Typography>
					</Link>
					<div className="button-separator" />
					<Link
						to={noteLink}
						className="appointment-button no-underline-link black-text">
						<Typography className="normal-text" textAlign="center">
							{noteText}
						</Typography>
					</Link>
				</div>
			</div>
		</div>
	);
}
